import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Input from "@mui/material/Input";
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

// import UserCreateForm from "./UserCreateForm";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import { axiosDelay } from "../../../config/config";

import {
    appSetAlert
} from "../../../redux/app/appActions";

import {
	dataReloadDependants, dataReloadSources
} from "../../../redux/data/dataActions";
import useDataSource from "../../../hooks/useDataSource";

const PREFIX = 'UserGroupNewDialog';

const classes = {
    dialogContent: `${PREFIX}-dialogContent`,
    form: `${PREFIX}-form`,
    margin: `${PREFIX}-margin`,
    formEmbeddedActions: `${PREFIX}-formEmbeddedActions`
};

const StyledDialog = styled(Dialog)((
    {
        theme
    }
) => ({
    [`& .${classes.dialogContent}`]: {
        minWidth: '400px',
        maxWidth: '400px',
        minHeight: '320px',
        maxHeight: '320px'
    },

    [`& .${classes.form}`]: {
        height: '300px'
    },

    [`& .${classes.margin}`]: {
        margin: '8px', // theme.spacing(1),
        width: 'calc(100% - 8px)'
    },

    [`& .${classes.formEmbeddedActions}`]: {
        position: 'absolute',
        bottom: '0px',
        width: 'calc(100% - 32px)'
    }
}));

export default function ModelOrdersNewDialog({ configuration, modelID, handleClose }) {

	// App State
	const authEmail = useSelector(state => state.auth.email);
	const config = useSelector(state => state.config);

	const dataSourceName = configuration?.dataSource?.name ? configuration?.dataSource?.name : '';
	const dataSource = useDataSource(dataSourceName);

	const orderIsUnique = async (modelorder) => {
		const orderExists = dataSource.data.find(d => d.modelorder.toLowerCase() === modelorder.toLowerCase() && d.modelid === modelID);

		if (orderExists) {
			return false;
		} else {
			return true;
		}
	};

    const schema = yup.object().shape({
        modelorder: yup.string().required().test("Order must be unique", "Order must be unique", orderIsUnique)
    });

    const resolver = yupResolver(schema);
    const { register, trigger, handleSubmit, formState, formState: { errors } } = useForm({ resolver });
    const dispatch = useDispatch();

    // Component State
    const [open, setOpen] = React.useState(true);

    const onSubmit = dataToPost => {
        // TODO: Any additional validation
        createModelOrder(dataToPost);
    };

    const createModelOrder = dataToPost => {
        setTimeout(function () {
			let requestBody = {
				fieldValues: []
			}

			const newRow = [
				{field: "modelid", value: modelID},
				{field: "modelorder", value: dataToPost.modelorder},
				{field: "lasteditedby", value: authEmail}
			]

			for (const item in newRow) {
				requestBody.fieldValues.push({
					field: newRow[item].field,
					value: newRow[item].value
				});
			}

			// Set api url and body
			const apiUrl = "{0}data?db={1}&table={2}".format(config.data.authentication.api, config.data.authentication.apiSource, "ModelOrders");

			// POST request to add a row
			axios
				.post(apiUrl, requestBody)
				.then(function (response) {
					// console.log(response);

					dispatch(appSetAlert(null, 'Row was successfully added.', 'success', 10000));
					dispatch(dataReloadDependants(["vwModelSetupVersions","vwModelVersions","vwCalibrationVersions"]))

					// Close the dialog and signal a reload
					handleClose(true);
				})
				.catch(function (error) {
					console.log('**ERROR**', error);

					dispatch(appSetAlert('Whoops!', 'Something went seriously wrong. Please try again.', 'error', 10000));
				});

		}, JSON.parse(axiosDelay()));
    };

    return (
        <StyledDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">New Model Version Order</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                    <FormControl variant="standard" className={classes.margin}>
                        <InputLabel htmlFor="input-with-icon-adornment">Model Version Order</InputLabel>
                        <Input
                            {...register("modelorder")}
                            name="modelorder"
                            id="modelorder"
                            startAdornment={
                                <InputAdornment position="start">
                                    <BookmarkBorderIcon />
                                </InputAdornment>
                            }
                            inputProps={{
                                "aria-label": "Order"
                            }}
                        />
                        {errors.modelorder && <p style={{color: 'red'}}>{errors?.modelorder?.message}</p>}
                    </FormControl>
                    <DialogActions className={classes.formEmbeddedActions}>
                        <Button onClick={handleClose} color="primary" disabled={formState.isSubmitting}>
                            Cancel
                        </Button>
                        <Button color="primary" type="submit" disabled={formState.isSubmitting}>
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </StyledDialog>
    );
}
